import {articleHttpRepository} from '../../website-ui/repositories/article-http-repository';
import {articleMemoryRepository} from '../../website-ui/repositories/article-memory-repository';
import {REQUEST_TIMEOUT_LIMIT} from '../constants';
import {getAccessToken} from '../tokens';

const getLanguage = langCode => {
  if (!langCode) {
    return 'ru';
  }

  return langCode?.toLowerCase() || 'ru';
};

const initComments = (config = {}, domain, $container, language, onLoaded) => {
  if (!domain || !$container || !config.asset_id) {
    return;
  }

  let scriptTimeoutId; /* eslint-disable-line */
  const $script = document.createElement('script');

  $script.setAttribute('defer', true);

  $script.src = `${domain}static/embed.js`;

  $script.onload = () => {
    clearTimeout(scriptTimeoutId);
    window.CoralEmbed = window.Coral.Talk.render(
      $container,
      {
        talk: domain,
        lazy: false,
        auth_token: getAccessToken() || 'not-valid-token', // logout user if token not valid
        language,
        ...config
      }
    );

    if (onLoaded) {
      setTimeout(onLoaded, 1000);
    }
  };

  document.head.appendChild($script);
  scriptTimeoutId = setTimeout(() => {
    throw new Error(`failed to load Talk script, timeout ${REQUEST_TIMEOUT_LIMIT}`);
  }, REQUEST_TIMEOUT_LIMIT);
};

export const renderComments = config => ($container, onLoaded) => {
  const {talkDomain, targeting} = window.Site;
  const language = getLanguage(targeting?.language);

  initComments(config, talkDomain, $container, language, onLoaded);
};

export const getCommentsCount = articleId => {
  articleHttpRepository.get(articleId)
    .then(data => {
      if (data) {
        articleMemoryRepository.set(data);
        if (data.commentCount) {
          const $article = document.querySelector(`.layout-content-type-page__main[data-id="${articleId}"]`);

          if ($article) {
            const $element = $article.querySelector('.js-comments-title');

            if ($element) {
              $element.textContent = `${$element.textContent}: ${data.commentCount}`;
            }
          }
        }
      }
    });
};
